import BaseResource from './index'
import GroupResource from './group'
import { formatDuration } from '@/util'

export default class CarResource extends BaseResource {
    static endpoint = '/cars'

    static related() {
        return {
            groups: GroupResource
        }
    }

    getTotalTimePretty() {
        return formatDuration(this.attributes.time_millis)
    }

    async getPreviewImageURL() {
        const response = await this.wrap('/content/preview').get()

        if (response.status == 200) {
            return response.data.url
        }

        return null
    }
}

export class CarSkinResource extends BaseResource {
    static endpoint = '/skins'

    static related() {
        return {
            car: CarResource
        }
    }

    async getPreviewImageURL() {
        const response = await this.wrap('/content/preview').get()

        if (response.status == 200) {
            return response.data.url
        }

        return null
    }
}
